import { render, staticRenderFns } from "./MatchDuration.vue?vue&type=template&id=23cb8e3a&scoped=true&"
import script from "./MatchDuration.vue?vue&type=script&lang=js&"
export * from "./MatchDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb8e3a",
  null
  
)

export default component.exports